// extracted by mini-css-extract-plugin
export var flowchartContainer = "_8-0";